export default function delay(ms: number): Promise<unknown> {
  return new Promise(resolve => setTimeout(resolve, ms))
}
